import React, { Component } from 'react';
import Link from 'next/link';
import { Input } from 'antd';
import { getAllJobs, jobFilterInputChange, applyModalOpen } from "../src/store/actions";
import { connect } from "react-redux";

class About extends Component {
    static async getInitialProps(ctx) {
        return {
            title: 'What is Rojgari Sanjal | About Rojgari sanjal',
            meta_desc: 'RojgariSanjal, a free  job portal, is a modern name for an online job platform that acts as a mediator between job seekers and employers, As the name  Rojgari Sanjal.',
            keywords: 'what is rojgari sanjal, modern job portal, employee and employers meeting platform, free job platform,  Post free Vacancy in Nepal,Free job portal in Nepal, job posting site in nepal, best job portal in nepal, no1 job portal in nepal, large job portal in nepal, find employee in nepal, how to post vacancy in Nepal, post job ads in nepal, post vacancy in nepal',
            showFooter: true
        }
    }

    render() {
        return (<div>
            <div className="tr-breadcrumb bg-image section-before jobs-listing">
                <div className="container">
                    <div className="breadcrumb-info text-center">
                        <h2>ABOUT US</h2>

                        <ul className="job-meta tr-list list-inline">
                            <li>
                                <Link href={'/'}><a href={''}><i className="fas fa-home" />{'Rojgari Sanjal'}</a></Link>
                                &nbsp;&nbsp;<i className="fas fa-chevron-right" /><span
                                    style={{ color: '#ccc' }}>About Us</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="job-list-container">
                <div className="container">
                    <div className="about-para">
                        <p><strong>RojgariSanjal</strong>, a job portal, is a modern name for an online job platform
                            that acts as a
                            mediator
                            between job seekers and employers. As the name suggests, <strong>RojgariSanjal</strong> is a
                            network of
                            opportunities to both applicants in finding jobs and employers in their quest to find ideal
                            candidates.
                        </p>

                        <p>
                            Gone are the days, when one had to scoot over every newspaper’s career editorials in search
                            of
                            career options. Yes, talking about your joblessness to close friends and family hoping for
                            some
                            kind of reference can be brutal at times. Well, you are one click away from paving your
                            career
                            or changing your career paths. We offer a broad range of jobs in a vast number of
                            fields.</p>
                        <p><strong>RojgariSanjal</strong> lets you apply for countless job postings by leading
                            organizations. All
                            you
                            need to do is create a profile and browse jobs by location, role, market, technology and
                            salary.
                            it’s that simple! <br /> <Link href={'/auth/register'}><a href="">(Get Started
                                Now)</a></Link></p>
                    </div>
                </div>
            </div>

        </div>);
    }

    componentDidMount() {
        const html = document.querySelector('html');
        html.style.height = 'initial';
    }
}

const mapStateToProps = (state) => {
    return {
        category: state.category,
        job: state.job
    }
};

export default connect(mapStateToProps, { jobFilterInputChange, getAllJobs, applyModalOpen })(About);